import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";

import { useStyles } from "../../../Components/CSS/UserDetailStyle.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { url } from "../../../Config/Config";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import ExaminationBody from "./ExaminationBody/ExaminationBody";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserExamination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exams: [],
    };
  }

  componentDidMount() {
    this.getUserSyllabus();
  }

  getUserSyllabus = async () => {
    try {
      let responseStudent = {};
      if (this.props.role === "Teacher") {
        const response = await Axios.get(`${url}/api/exams`, {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        if (response.data.exams.length !== 0) {
          this.setState({
            exams: response.data.exams,
            isEmpty: false,
          });
        } else {
          this.setState({
            exams: [],
            isEmpty: true,
          });
        }
      } else {
        responseStudent = await Axios.get(
          `${url}/api/students/${this.props.userId}`,
          {
            headers: {
              Authorization: `Bearer ${this.props.userToken}`,
            },
          }
        );
        const response = await Axios.get(`${url}/api/exams`, {
          params: {
            session: responseStudent.data.student.currentSession,
            studentClass: responseStudent.data.student.studentClass,
            faculty: responseStudent.data.student.faculty
              ? responseStudent.data.student.faculty
              : "",
            group: responseStudent.data.student.group
              ? responseStudent.data.student.group
              : "",
            section: responseStudent.data.student.section,
          },
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        if (response.data.exams.length !== 0) {
          this.setState({
            exams: response.data.exams,
            isEmpty: false,
          });
        } else {
          this.setState({
            exams: [],
            isEmpty: true,
          });
        }
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserSyllabus();
      }
    }
  };

  render() {
    const { classes } = this.props;
    let currentMonthExam = this.state.exams.filter((data) => {
      return (
        moment(data.startDate).format("YYYY") ===
          moment(new Date()).format("YYYY") &&
        moment(data.startDate).format("MMM") ===
          moment(new Date()).format("MMM")
      );
    });
    let oldMonthExam = this.state.exams.filter((data) => {
      return (
        moment(data.startDate).format("YYYY") ===
          moment(new Date()).format("YYYY") &&
        moment(data.startDate).format("MMM") !==
          moment(new Date()).format("MMM")
      );
    });
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          {this.state.exams.length !== 0 ? (
            <div>
              <div className={classes.setionDesktop}>
                <PageTitle
                  title="Examination"
                  refreshUrl={this.props.match.url}
                />
              </div>
              <div className={classes.sectionMobile}>
                <PageTitle title="Examination" />
              </div>
              {currentMonthExam.map((exam, index) => (
                <ExaminationBody
                  role={this.props.role}
                  key={index}
                  exam={exam}
                />
              ))}
              {oldMonthExam.map((exam, index) => (
                <ExaminationBody
                  role={this.props.role}
                  key={index}
                  exam={exam}
                />
              ))}
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserExamination));
